import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControlComponent } from '../form-control/form-control.component';

@Component({
  selector: 'rav-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent extends FormControlComponent {
  @Output() isPasswordVisibleChange = new EventEmitter<boolean>();
  @Input() hasLabel = true;
  @Input() isPassword = false;
  @Input() placeholder?: string;
  @Input() autocomplete = true;
  @Input() dataCy = '';

  @Input() get isPasswordVisible() {
    return this.isPasswordVisibleValue;
  }

  set isPasswordVisible(value) {
    this.isPasswordVisibleValue = value;
    this.isPasswordVisibleChange.emit(this.isPasswordVisibleValue);
  }

  isPasswordVisibleValue = false;
  constructor() {
    super();
  }
}
